import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { UserRoutingModule } from '../user-routing/user-routing.module';
import { VaultObjectgroupService } from '../vaultobject-popup-screen/vault-objectgroup.service';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { UploadExcelFileComponent } from '../upload-excel-file/upload-excel-file.component';
import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';
import { LoadobjectmstrPopupComponent } from './loadobjectmstr-popup/loadobjectmstr-popup.component';

@Component({
    selector: 'app-loadobjectmstr',
    templateUrl: './loadobjectmstr.component.html',
    styleUrls: ['./loadobjectmstr.component.scss'],
    standalone: false
})
export class LoadobjectmstrComponent implements OnInit {

 frameworkComponent
  columnDefs
  defaultColDef
  paginationPageSize
  paginationNumberFormatter
  rowClassRules
  backgroundColor
  gridApi
  lastpage
  currentpage
  nextpage
  nextpageplusone
  totalpages
  pagesize
  components
  buttonColor
  backgroundColorScreen
  getdata
  updatedData: null;
  buttonName: any;
  bootstrapColumn: number;
   buttonIdList = []
  getRowStyle: (params: any) => { backgroundColor: string; };
  excelData: any;
  dnsId: string;
  tableName= "loadobjectsmstr";


  constructor(private snackbar:MatSnackBar,private localStorrageSettings:LocalStorageSettingsService,private spinner:NgxUiLoaderService,
    private dialog: MatDialog,private commonService: CommonService,private userRoutingModule: UserRoutingModule,
     private reportLinkService:ReportlinksserviceService)
   {this.components ={
     buttonRenderer: Actionbutton,
   }}

  /*Author- Renuka chama
  04/02/2026
  For creation of  loadobjectmstr screen 
  */

  ngOnInit(): void {
    console.log('LoadObjectMstrComponent loaded');
     this.tableName= 'loadobjectsmstr'
   this.dnsId = this.localStorrageSettings.getSettings("dnsName")
         let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorrageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });
     
    this.paginationPageSize = 10;
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.columnDefs = [{
      headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
      pinned:'left',
      lockPinned:true,
      cellRendererParams: {
        values:this.buttonIdList,
        edit: this.editIcon.bind(this),
        delete: this.deleteIcon.bind(this),
      }, width: 150
    },
    {
      headerName: 'Load Object Id',
      headerTooltip: 'Load Object Id',
      tooltipValueGetter: (params) => 'Load Object Id : ' + params.value,
      field: 'LoadObjectsMstrId',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Name',
      headerTooltip: 'Object Name',
      tooltipValueGetter: (params) => 'Object Name : ' + params.value,
      field: 'objectName',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Load Order',
      headerTooltip: 'Load Order',
      tooltipValueGetter: (params) => 'Load Order : ' + params.value,
      field: 'loadOrder',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Is Loadable',
      headerTooltip: 'Is Loadable',
      tooltipValueGetter: (params) => 'Is Loadable : ' + params.value,
      field: 'isloadable',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Is Parent',
      headerTooltip: 'Is Parent',
      tooltipValueGetter: (params) => 'Is Parent : ' + params.value,
      field: 'isParent',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Level',
      headerTooltip: 'Object Level',
      tooltipValueGetter: (params) => 'Object Level : ' + params.value,
      field: 'level',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Deferred',
      headerTooltip: 'Deferred',
     tooltipValueGetter: (params) => 'Deferred : ' + params.value,
      field: 'deferred',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Vault Extraction(Yes/No)',
      headerTooltip: 'Vault Extraction(Yes/No)',
      tooltipValueGetter: (params) => 'Vault Extraction : ' + params.value,
      field: 'vaultExtraction',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Vql Criteria',
      headerTooltip: 'Vql Criteria',
      tooltipValueGetter: (params) => 'Vql Criteria : ' + params.value,
      field: 'vqlCriteria',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Global Object',
      headerTooltip: 'Global Object',
      tooltipValueGetter: (params) => 'Global Object : ' + params.value,
      field: 'requiresGlobalObject',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Parent Object Name For Extraction',
      headerTooltip: 'Parent Object Name For Extraction',
      tooltipValueGetter: (params) => 'Parent Object Name : ' + params.value,
      field: 'parentObjectNameForExtraction',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Type',
      headerTooltip: 'Type',
      tooltipValueGetter: (params) => 'Type : ' + params.value,
      field: 'type',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Type',
      headerTooltip: 'Object Type',
      tooltipValueGetter: (params) => 'Object Type : ' + params.value,
      field: 'objectType',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'File Name',
      headerTooltip: 'File Name',
      tooltipValueGetter: (params) => 'File Name : ' + params.value,
      field: 'fileName',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Deletion Level',
      headerTooltip: 'Deletion Level',
      tooltipValueGetter: (params) => 'Deletion Level : ' + params.value,
      field: 'deletionLevel',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Load Action',
      headerTooltip: 'Load Action',
      tooltipValueGetter: (params) => 'Load Action : ' + params.value,
      field: 'loadAction',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Group Name',
      headerTooltip: 'Object Group Name',
      tooltipValueGetter: (params) => 'Object Group Name : ' + params.value,
      field: 'objectgroupname',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Source Data Extraction VQL',
      headerTooltip: 'Source Data Extraction VQL',
      tooltipValueGetter: (params) => 'Source Data Extraction VQL : ' + params.value,
      field: 'sourceDataExtractionVql',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Migration Mode',
      headerTooltip: 'Migration Mode',
      tooltipValueGetter: (params) => 'Migration Mode : ' + params.value,
      field: 'migrationmode',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Self Reference Object',
      headerTooltip: 'Self Reference Object',
      tooltipValueGetter: (params) => 'Self Reference Object : ' + params.value,
      field: 'selfreferenceobject',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Self Reference Fields',
      headerTooltip: 'Self Reference Fields',
      tooltipValueGetter: (params) => 'Self Reference Fields : ' + params.value,
      field: 'selfreferencefields',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Circular Reference Object',
      headerTooltip: 'Circular Reference Object',
      tooltipValueGetter: (params) => 'Circular Reference Object : ' + params.value,
      field: 'circularreferenceobject',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Circular Reference Fields',
      headerTooltip: 'Circular Reference Fields',
      tooltipValueGetter: (params) => 'Circular Reference Fields : ' + params.value,
      field: 'circularreferencefields',
      filter: 'agTextColumnFilter',
      width: 230
    },
     { 
      headerName: 'Status', 
      headerTooltip: 'Status', 
      tooltipValueGetter: (params) => 'Status : ' + params.value, 
      field: 'status', 
      filter: 'agTextColumnFilter', width: 250,  
        cellStyle: function (params){
          if (params.value == 'Yes'){
            return { color: 'green' };
          } else {
            return { color: 'red' };
          }
        } 
      },    
    ],

    this.getRowStyle = (params: any) => {
      console.log(params)
      console.log(params.data.status)
      if (params.data.status === 'No') {
        return { backgroundColor: 'rgb(211, 211, 211)' }; // Inline style for deleted rows
      }
    };

    this.buttonColor = this.localStorrageSettings.getSettings("ColorA")
    this.backgroundColorScreen = this.localStorrageSettings.getSettings("ColorD")

  }
  
  onBtExport() {
    this.gridApi.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.api.paginationGoToLastPage();
  }
  onGridReady(params){
    this.gridApi = params;
    params.api.setGridOption('rowData', [])
    this.spinner.start()
    var tenantId = localStorage.getItem('dnsName');
     console.log(tenantId)
     console.log("dnsId =", this.dnsId);
     this.retrieve(tenantId)
  }

  refreshRun() {
    this.spinner.start();
    this.onGridReady(this.gridApi);
    this.spinner.stop();
  }

  

  retrieve(tenantId){

    console.log("inside retrival")
    this.commonService.retrieveLoadObjectsFromLoadObjectsmstr(this.dnsId).subscribe(response=>{
      console.log("API RESPONSE =", response);   

      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = null;
        this.gridApi.api.setGridOption('rowData', this.getdata)
      }else{
        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.gridApi.api.setGridOption('rowData', this.getdata)
        this.spinner.stop();
      }

      if(Array.isArray(response)){
        this.gridApi.api.setGridOption('rowData', response);
      } else if(Array.isArray(response.data)){
        this.gridApi.api.setGridOption('rowData', response.data);
      } else if(Array.isArray(response.result)){
        this.gridApi.api.setGridOption('rowData', response.result);
      } else {
        console.error("Grid received non-array data");
        this.gridApi.api.setGridOption('rowData', []);
      }
     
      
    })
  }

   
  openSaveForm(buttonName) {
    this.buttonName = buttonName;
   
    let width = '80%';

    if (this.bootstrapColumn == 1) {

      width = '55%';

    }
    var obj={}
    let dialogRef = this.dialog.open(LoadobjectmstrPopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '80%',
      height:'90%',
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      // this.retrieveLoadObjectsFromLoadObjectsmstr();

     if (this.gridApi) {
      this.onGridReady(this.gridApi); // Call onGridReady after the popup closes
  }
    });
    
  }

    editIcon(e) {
      let rowData = e.rowData;
      console.log(e.rowData);
      console.log(e.rowData);
      var obj = e.rowData
      console.log(obj);
      console.log(event);
      if(e.rowData.status === "No"){
        this.snackbar.open("Selected record is already deleted","OK",{duration:5000});
        return;
      }
      let dialogRef = this.dialog.open(LoadobjectmstrPopupComponent, {
        panelClass: 'custom-dialog-container-materialFulfilment',
        width: '80%',
        height: '90%',
        autoFocus: false,
        data: { edata: obj},
        disableClose: true,
      });
  
      dialogRef.afterClosed().subscribe(result=>{
        if (this.gridApi) {
          this.onGridReady(this.gridApi); 
      }
      })
  
    }

    
  deleteIcon(event) {
    console.log(event);

    if(event.rowData.status === "No"){
      this.snackbar.open("Selected record is already deleted","OK",{duration:5000});
      return;
    }
    if(confirm("Are you sure you want to delete this record?")){
      this.spinner.start();
      const deleteId = event.rowData.LoadObjectsMstrId;
      this.commonService.deleteLoadObjectsMstr(deleteId).subscribe(result=>{
        console.log("Delete response:", result);
        if(result.statusMessage === "Successfully record is deleted"){
          this.snackbar.open(result.statusMessage, "OK",{duration:5000});
        }else{
          this.snackbar.open("Cannot delete selected record", "OK",{duration:5000});
        }
        this.refreshRun();
        this.spinner.stop();
      });
    }
    
  }

  
       
  excelFileUploadForObjects(){
    const tablename= 'loadobjectsmstr'
    let selectedNameOfdns
    selectedNameOfdns = this.localStorrageSettings.getSettings("dnsName")
    console.log(selectedNameOfdns)
    let dialogRef = this.dialog.open(UploadExcelFileComponent, {
                panelClass: 'custom-dialog-container-materialFulfilment',
                width: '95%',
                height:'80%',
                maxWidth:'100vw',
                autoFocus: false,
                data: { edata:tablename,dnsname:selectedNameOfdns},
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe(result => {
              console.log(result)
               if(result){
                this.excelData = result
                  this.refreshRun()
              //  this.sendExcelData()
               }
                  this.refreshRun()
              //  input.value = '';
            })
        
    }
    
  
  
    importData() {
      // if (this.headerNameHtml == "Objects") {
      //   this.importExportTableName = "objectmetadata    ";
  
      //  }
      
          console.log("<--- Inside upload Group Template --->")
          let width = "85%";
        let dialogRef = this.dialog.open(ImportJsonComponent, {
            maxWidth: "70vw",
            height: "50%",
            width: width,
          data: { "tablename": this.tableName,tenantid:this.dnsId},
            disableClose: true,
          });
        
          dialogRef.afterClosed().subscribe((result) => {
            console.log(result);
        
            //this.reportCreationData = result;
        
            //this.vaultObjectService.retrieveobjectgroup();
          });
        
        
      }
      
    
      async exportData() {
        this.snackbar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
        let tenantid = localStorage.getItem("dnsName")
  
        // if (this.headerNameHtml == "Objects") {
        //   this.importExportTableName = "objectmetadata";
        //   tenantid = this.dnsid+"";
  
        // }
       
    
          try {
            const blob = await this.commonService.downloadJsonFile(this.tableName, tenantid);
            const link = document.createElement('a');
            const timestamp = new Date().getTime();
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.tableName}_export_${timestamp}.json`;
            link.click();
            window.URL.revokeObjectURL(link.href);
    
          } catch (error) {
            console.error('Error downloading JSON:', error);
          }
        
        
      }

}

